import React, { Component, Fragment } from "react";
import { Row, Col, Table, Card, CardBody } from "reactstrap";
import { Roles } from "../../constants/constant.role";

class SingleDealerPrimaryReportTable extends Component {
  render() {
    const {
      dealer,
      getIndividualFleetManagesFleets,
      dealerRole,
      isFmSelected,
      currentUser,
    } = this.props;

    const prepareHeader = dealer.salesData.map(sd => (
      <th>{sd.sub_category}</th>
    ));
    const prepareOfftake = dealer.salesData.map(sd => <td>{sd.offtake}</td>);
    const preparePoints = dealer.salesData.map(sd => <td>{sd.points}</td>);

    return (
      <Fragment>
        <Row className="margin-top-10">
          <Col>
            <Card>
              <CardBody className="overflow-auto">
                <Row className="margin-bottom-20">
                  <Col className="text-align-left">
                    <div
                      className="single-dealer-table-card-header"
                    // onClick={getIndividualFleetManagesFleets.bind(this, dealer.uuid, dealer.business_name)}
                    >
                      <span className="title-case">
                        {dealer.business_name
                          ? `${dealer.business_name} / `
                          : ""}
                      </span>
                      {dealer.member_id}
                    </div>
                  </Col>
                  <Col className="text-align-right download-report-text">
                    {(dealer.parent_subsidiary && dealer.parent_subsidiary === true) || (!dealer.hasOwnProperty('parent_subsidiary')) ?
                      <div
                        className=" cursor-pointer d-inline-block"
                        onClick={
                          (currentUser &&
                            currentUser.role &&
                            currentUser.role === "FM") ||
                            dealerRole === Roles.FLEET_MANAGER_ROLE
                            ? this.props.openViewReportPage.bind(
                              this,
                              dealer.uuid,
                              dealer.business_name,
                              dealer.member_id,
                              dealer.type
                            )
                            : getIndividualFleetManagesFleets.bind(
                              this,
                              dealer.uuid,
                              dealer.business_name,
                              dealer.type
                            )
                        }
                      >
                        View detailed report
                      </div>
                      :
                      <div
                        className="lblSubsidiary"
                      >Subsidiary</div>
                    }
                  </Col>
                </Row>

                <Table>
                  <thead>
                    <tr>
                      <th></th>
                      {prepareHeader}
                      {/* <th>PCR</th>
                    <th>TBB</th>
                    <th>TBR</th>
                    <th>LCV</th>
                    <th>SCV</th>
                    <th>2/3 Wheeler</th>
                    <th>Farm</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="table-header">
                        Offtake
                      </td>
                      {prepareOfftake}
                      {/* <td>0</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td> */}
                    </tr>
                    <tr>
                      <td className="table-header">
                        Points
                      </td>
                      {preparePoints}
                      {/* <td>0</td>
                    <td>0</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td>
                    <td>1</td> */}
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default SingleDealerPrimaryReportTable;
